import { View } from "@react-pdf/renderer";
import { getNonCoveredProcedures } from "helpers/abn";
import { useMemo } from "react";

import { BreakdownTable } from "./BreakdownTable";

export function NoDiscountPdfBreakdown({
  insuranceBenefits,
  paymentBreakdown,
  serviceDetails,
  orderType,
  clearPrice,
}: {
  insuranceBenefits: any;
  paymentBreakdown: any;
  serviceDetails?: any;
  orderType?: string;
  clearPrice: number;
}) {
  const isSelfPayRate = useMemo(() => {
    return insuranceBenefits?.[0]?.name === "Self-Pay Rate";
  }, [insuranceBenefits]);

  const nonCoveredProcedures = useMemo(() => {
    if (!serviceDetails) return [];
    return getNonCoveredProcedures({ orderType, serviceDetails });
  }, [serviceDetails, orderType]);
  const paymentBreakdownWithCptCodes = useMemo(() => {
    if (!paymentBreakdown || !serviceDetails) return null;

    // Get non-covered CPT codes to exclude them
    const nonCoveredCPTCodes = nonCoveredProcedures.map((p: any) => p?.code);

    // Create a map of specialty to CPT codes from serviceDetails (only covered procedures)
    const specialtyToCptCodes: Record<string, string[]> = {};

    if (serviceDetails.procedures) {
      serviceDetails.procedures
        .filter(
          (procedure: any) => !nonCoveredCPTCodes.includes(procedure.code)
        ) // Only covered procedures
        .forEach((procedure: any) => {
          const specialty = procedure.specialty || "UNKNOWN";
          const cptCode = procedure.code;

          if (!specialtyToCptCodes[specialty]) {
            specialtyToCptCodes[specialty] = [];
          }

          if (cptCode && !specialtyToCptCodes[specialty].includes(cptCode)) {
            specialtyToCptCodes[specialty].push(cptCode);
          }
        });
    }

    // Add CPT codes to each breakdown row
    return paymentBreakdown.map((row: any) => ({
      ...row,
      cptCodes: specialtyToCptCodes[row.specialty] || [],
    }));
  }, [paymentBreakdown, serviceDetails, nonCoveredProcedures]);

  return (
    <View wrap>
      <View
        style={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {paymentBreakdownWithCptCodes && (
          <BreakdownTable
            breakdown={paymentBreakdownWithCptCodes as any}
            nonCoveredProcedures={nonCoveredProcedures as any}
            clearPrice={clearPrice}
            isSelfPayRate={isSelfPayRate}
          />
        )}
      </View>
    </View>
  );
}
